import "./App.css";
import Nav from "./components/Hero/Nav";
import HeroSection from "./components/Hero/HeroSection";
import About from "./components/About/About";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import Feature from "./components/HowItWorks/Feature";
import Testimonials from "./components/Testimonials/Testimonials";
import FAQ from "./components/FAQ/FAQ.jsx";
import JoinAsRiderContainer from "./components/JoinAsRider/JoinAsRiderContainer.jsx";
import Footer from "./components/Footer/Footer.jsx";
import Why from "./components/WHY/Why.jsx";
import { Route, Routes } from "react-router-dom";
import Contact from "./components/Contact/Contact.jsx";
import TermOfService from "./pages/TermsOfService.jsx";
import TermsOfServiceForPartners from "./pages/TermsOfServiceForPartners.jsx";
import Privacy from "./pages/Privacy.jsx";
import CancellationAndRefund from "./pages/CancellationAndRefund.jsx";
import BulkOrder from "./pages/BulkOrder.jsx";

function App() {
  return (
    <>
      <Nav />
      <Routes>
        <Route
          path="/"
          element={
            <div className="font-generalSans flex justify-center flex-col lg:gap-[104px] gap-[81px] scroll-smooth">
              <div className="flex flex-col">
                <HeroSection />
              </div>
              <About />
              <Why />
              <HowItWorks />
              <Feature />
              <Testimonials />
              <FAQ />
              <Contact />
              <JoinAsRiderContainer />
            </div>
          }
        />
        <Route path="/terms/user" element={<TermOfService />} />
        <Route path="/terms/partner" element={<TermsOfServiceForPartners />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<CancellationAndRefund />} />
        <Route path="/bulk/order/:orderId" element={<BulkOrder />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
